import type { OtherAsset } from "~/types/assets.types";
import { calculateOtherYears } from "./years";

export const otherCurrentYield = (userProduct: OtherAsset) => {
  const balance = userProduct?.currentValue || 0;
  const buyingPrice = userProduct?.buyingPrice || 0;
  const years = calculateOtherYears(userProduct);

  if (Number(balance) === 0 || Number(years) === 0) return 0;
  return (balance - buyingPrice) / buyingPrice / years;
};
